import { HTTP_METHODS } from '@studio/constants/axios';
import { ONBOARDING_API_V1 } from '@studio/constants/env-variables';
import type { Onboarding } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    method: HTTP_METHODS.POST,
    url: `${ONBOARDING_API_V1}/customers/@customerId/trials/@ecgTrialId/cancel`,
    request: {} as Onboarding.Post.CancelTrial,
    params: {} as { ecgTrialId: string | undefined },
  },
};
